import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import { useSearchContext } from '@src/main/ui/providers/search/SearchContextProvider';
import { FC } from 'react';
import Highlighter from 'react-highlight-words';

interface Props {
  title: string;
  highlighFields?: HighlighFields[];
}

const defaultProps = {
  highlighFields: undefined,
};

const TitleCardText: FC<Props> = ({ title, highlighFields }) => {
  const { searchInput } = useSearchContext();
  const fieldToHighligh: HighlighFields = 'title';
  return (
    <>
      {highlighFields?.includes(fieldToHighligh) ? (
        <Highlighter searchWords={[searchInput]} textToHighlight={title} />
      ) : (
        title
      )}
    </>
  );
};

TitleCardText.defaultProps = defaultProps;

export default TitleCardText;
